<template>
    <v-container fluid>
        <v-row>
            <v-col cols="12" md="4">
                <v-card class="pa-2">
                    <v-card-title>
                        <h4>Détail de la demande</h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text>
                        <b>Cabinet: </b>
                        {{ this.$store.getters["Auth/get_selected_sollicitation"].prenom }}
                        <v-spacer class="my-1"></v-spacer>
                        <b>Nom du chargé: </b>
                        {{ this.$store.getters["Auth/get_selected_sollicitation"].nom }}
                        <v-spacer class="my-1"></v-spacer>
                        <b>E-mail: </b>
                        {{ this.$store.getters["Auth/get_selected_sollicitation"].email }}
                        <v-spacer class="my-1"></v-spacer>
                        <b>Société: </b>
                        {{ this.$store.getters["Auth/get_selected_sollicitation"].societe }}
                        <v-spacer class="my-1"></v-spacer>
                        <b>Date Demande: </b>
                        {{ this.$store.getters["Auth/get_selected_sollicitation"].dateDemande }}
                        <v-spacer class="my-1"></v-spacer>
                    </v-card-text>
                </v-card>

                <div>
                    <v-card class="pa-2 mt-2">
                        <v-card-title>
                            <h4>Voir les autres pièces</h4>
                        </v-card-title>
                        <v-divider></v-divider>
                        <v-card-text>
                            <v-row>
                                <v-list-item class="block text-truncate">
                                    <v-list-item-content>
                                        <v-list-item-title class="primary--text text-truncate font-weight-bold">
                                            Copie du Contrat : {{
                            this.$store.getters["Auth/get_selected_sollicitation"].copieContratName }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn small icon @click="viewFile('copieContratLink')">
                                            <v-icon color="grey lighten-1">mdi-eye</v-icon>
                                        </v-btn>

                                    </v-list-item-action>
                                </v-list-item>
                            </v-row>
                            <v-row>
                                <v-list-item class="block text-truncate">
                                    <v-list-item-content>
                                        <v-list-item-title class="primary--text text-truncate font-weight-bold">
                                            Preuve d'éxecution: {{
                            this.$store.getters["Auth/get_selected_sollicitation"].preuveExecutionName
                        }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn small icon @click="viewFile('preuveExecutionLink')">
                                            <v-icon color="grey lighten-1">mdi-eye</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-row>
                            <v-row>
                                <v-list-item class="block text-truncate">
                                    <v-list-item-content>
                                        <v-list-item-title class="primary--text text-truncate font-weight-bold">
                                            Mémoire du contrat: {{
                            this.$store.getters["Auth/get_selected_sollicitation"].memoireContratName }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn small icon @click="viewFile('memoireContratLink')">
                                            <v-icon color="grey lighten-1">mdi-eye</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-row>
                            <v-row>
                                <v-list-item class="block text-truncate">
                                    <v-list-item-content>
                                        <v-list-item-title class="primary--text text-truncate font-weight-bold">
                                            Autres pièces: {{
                            this.$store.getters["Auth/get_selected_sollicitation"].autresPiecesName }}
                                        </v-list-item-title>
                                    </v-list-item-content>
                                    <v-list-item-action>
                                        <v-btn small icon @click="viewFile('autresPiecesLink')">
                                            <v-icon color="grey lighten-1">mdi-eye</v-icon>
                                        </v-btn>
                                    </v-list-item-action>
                                </v-list-item>
                            </v-row>
                        </v-card-text>
                    </v-card>
                </div>

                <v-card class="mt-2">
                    <v-card-title id="v-step-0">
                        <h4>Intervenir sur la sollicitation</h4>
                    </v-card-title>
                    <v-card-text>
                        <!-- Menu déroulant pour le choix "Valider" ou "Non Valider" -->
                        <v-select v-model="isValidChoice" :items="['Donner son avis', 'Repondre à la demande']"
                            label="Que voulez-vous faire ?"></v-select>

                        <!-- Champs qui s'affichent lorsque "Valider" est choisi -->
                        <div v-if="isValidChoice === 'Donner son avis'">
                            <v-text-field v-model="sollicitation.objet_avis" label="Objet"></v-text-field>
                            <v-file-input v-model="sollicitation.avis_file" multiple label="Joindre le fichier"
                                truncate-length="15">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </div>

                        <!-- Champs qui s'affichent lorsque "Non Valider" est choisi -->
                        <div v-if="isValidChoice === 'Repondre à la demande'">
                            <v-text-field v-model="sollicitation.objet_response" label="Objet"></v-text-field>
                            <v-file-input v-model="sollicitation.file_response" multiple
                                label="Joindre le procès verbal" truncate-length="15">
                                <template v-slot:selection="{ text }">
                                    <v-chip small label color="primary">{{ text }}</v-chip>
                                </template>
                            </v-file-input>
                        </div>
                        <v-btn small color="primary" class="ma-2 white--text" block @click="submitResponse">
                            <v-icon class="mr-2" dark>mdi-cloud-upload</v-icon>Envoyer
                        </v-btn>
                    </v-card-text>
                </v-card>

            </v-col>
            <v-col cols="12" md="8">
                <v-card>
                    <v-card-title>
                        <h4>Aperçu de la sollicitation</h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <v-card-text style="height:62em !important;overflow:hidden">
                        <VueDocPreview style="height:100%" v-if="this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'doc' ||
                            this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'docx' ||
                            this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'xls' ||
                            this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'xlsx' ||
                            this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'XLS' ||
                            this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'XLSX'
                            " :value="this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeLink"
                            type="office" />

                        <vue-friendly-iframe
                            v-if="this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeType == 'pdf'"
                            :src="this.$store.getters['Auth/get_selected_sollicitation'].pieceJointeDemandeLink + '#toolbar=0'
                            " frameborder="0" loading="lazy"></vue-friendly-iframe>
                    </v-card-text>
                </v-card>
            </v-col>
        </v-row>

        <v-row justify="center" v-if="dialog">
            <v-dialog eager v-model="dialog" width="900px">
                <v-card>
                    <v-card-title>
                        <h4>Aperçu du fichier joint</h4>
                    </v-card-title>
                    <v-divider></v-divider>
                    <VueDocPreview v-if="isDocumentType(fileUrl)" :value="fileUrl" type="office" />
                    <vue-friendly-iframe v-else-if="isPdfType(fileUrl)" allow="true" :src="fileUrl" class="w-62em"
                        frameborder="0" loading="lazy"></vue-friendly-iframe>
                </v-card>
            </v-dialog>
        </v-row>

    </v-container>
</template>

<script>
import VueDocPreview from "vue-doc-preview";

export default {
    components: {
        VueDocPreview
    },
    props: {
        id: {
            type: Number,
            required: true
        }
    },
    data: () => ({
        profile: 0,
        dialog: false,
        isValidChoice: null,
        sollicitation: {
            objet_avis: "",
            avis_file: [],
            objet_response: "",
            file_response: [],
        },
        isValidChoice: null,
        fileName: "",
    }),
    created() {
        this.$store.dispatch("Auth/loadSollicitationById", this.id);
        let Virt = [];
        Virt = JSON.parse(localStorage.getItem("userData"));
        this.profile = Virt.profile.status;
    },
    methods: {
        getInit() {
            this.InitLink = this.$store.getters["Auth/get_selected_sollicitation"].piece_jointe_demande_link;
            console.log("INFOS", InitLink);
        },
        openDialog() {
            this.dialog = true;
        },
        closeDialog() {
            this.dialog = false;
        },
        isDocumentType(fileUrl) {
            const documentExtensions = ['doc', 'docx', 'xls', 'xlsx', 'XLS', 'XLSX'];
            const fileExtension = fileUrl.split('.').pop();
            return documentExtensions.includes(fileExtension);
        },
        isPdfType(fileUrl) {
            const pdfExtensions = ['pdf'];
            const fileExtension = fileUrl.split('.').pop();
            return pdfExtensions.includes(fileExtension);
        },
        viewFile(file) {
            // Récupérer l'URL du fichier spécifique à partir du store
            const fileUrl = this.$store.getters["Auth/get_selected_sollicitation"][file];

            // Vérifier si l'URL du fichier est définie et n'est pas vide
            if (fileUrl && fileUrl.trim() !== "") {
                // Stocker l'URL du fichier dans une variable pour l'afficher dans la modale
                this.fileUrl = fileUrl;

                // Afficher la modale pour visualiser le fichier
                this.dialog = true;
            } else {
                console.error("Le lien vers le fichier est invalide ou vide.");
            }
        },

        downloadFiche() {
            const data = new FormData();
            data.append("id", this.id);
            this.$store.dispatch("Auth/downloadFiche", data);
        },
        async submitResponse() {
            this.isLoading = true;
            try {
                if (this.isValidChoice === 'Donner son avis') {
                    // Call the validatePPM API here
                    const formData = new FormData();
                    formData.append('sollicitation_id', this.id);
                    formData.append('objet_avis', this.sollicitation.objet_avis);
                    formData.append('avis_file', this.sollicitation.avis_file[0]);
                    const response = await this.$store.dispatch("Auth/addAvisSollicitation", formData);
                    console.log(response);
                } else if (this.isValidChoice === 'Repondre à la demande') {
                    const formData = new FormData();
                    formData.append('sollicitation_id', this.id);
                    formData.append('objet_response', this.sollicitation.objet_response);
                    formData.append('file_response', this.sollicitation.file_response[0]);
                    const response = await this.$store.dispatch("Auth/addResponseSollicitation", formData);
                    this.isValidChoice = "";
                    this.sollicitation.file_response = null;
                    console.log(response);
                }

                // Réinitialisation après l'envoi de la réponse
                this.isValidChoice = null;
                this.sollicitation.objet_avis = "";
                this.sollicitation.avis_file = [];
                this.sollicitation.objet_response = "";
                this.sollicitation.file_response = [];
            } catch (error) {
                console.error(error);
            } finally {
                this.isLoading = false;
            }
        },
    }
};
</script>
<style>
.w-62em {
    height: 62em !important;
    width: 100% !important;
}

.v-card__text {
    width: 100% !important;
}

.vue-friendly-iframe iframe {
    width: 100% !important;
    height: 62em !important;
}
</style>